module.exports = "//static.hsappstatic.net/pricing-pages-lib/static-1.29018/images/keyFeatures/prospecting_agent.png"